import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ViewEntitlementComponent } from '@app/components/view-ush-entitlement/view-entitlement.component';
import { DataResolver } from '@app/shared/resolver/data-ush-resolver/data.resolver';
import { PageResolver } from '@app/shared/resolver/page.resolver';

const routes: Routes = [
  {
    path: '',
    component: ViewEntitlementComponent,
    resolve: {
      pageLabels: PageResolver,
      entitlementData: DataResolver,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EntitlementRoutingModule {}
